import { createSlice } from '@reduxjs/toolkit'
import {TOKENS} from '../../constants/constants'
let defaultTokenBalances = {}
Object.keys(TOKENS).map((token) => {
  defaultTokenBalances[token] = 0;
})


export const storageSlice = createSlice({
  name: 'storage',
  initialState: {
    wallet: null,
    betAmount: 0,
    betMultiplier: 1.33,
    degenMode: false,
    token: "SOL",
    mode: "SOL", // 3 types ["SOL", "Degen", "Token"]
    playState: "loading",
    recentBets: [],
    solBalance: 0,
    darkmode: false,
    accordionActiveKey: "0",
    showFaq: false,
    sound: true,
    userAnalytics: false,
    historicalAnalytics: false,
    tokenBalances: defaultTokenBalances
  },
  reducers: {
    setWallet: (state, action) => {
      state.wallet = action.payload
    },
    setRecentBets: (state, action) => {
      state.recentBets = action.payload
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    toggleDarkMode: (state, action) => {
      let oldmode = state.darkmode;
      state.darkmode = !oldmode
    },
    setSolBalance: (state, action) => {
      state.solBalance = action.payload
    },    
    setBetAmount: (state, action) => {
      state.betAmount = action.payload
    },
    setBetMultiplier: (state, action) => {
      state.betMultiplier = action.payload
    },      
    setAccordionActiveKey: (state, action) => {
      state.accordionActiveKey = action.payload
    },  
    setShowFaq: (state, action) => {
      state.showFaq = action.payload
    },
    toggleSound: (state, action) => {
      state.sound = action.payload
    },
    toggleDegenMode: (state, action) => {
      let oldmode = state.degenMode
      state.degenMode = !oldmode
    },
    toggleUserAnalytics: (state, action) => {
      state.historicalAnalytics = false
      let oldmode = state.userAnalytics
      state.userAnalytics = !oldmode
    },
    toggleHistoricalAnalytics: (state, action) => {
      state.userAnalytics = false
      let oldmode = state.historicalAnalytics
      state.historicalAnalytics = !oldmode
    },    
    setMode: (state, action) => {
      state.mode = action.payload
      if (action.payload == "SOL"){
        state.token = "SOL"
        state.betMultiplier = 10
        state.betAmount = 0.05        
      } else if (action.payload =="Degen") {
        state.token = "SOL"
        state.betMultiplier = 25
        state.betAmount = 0.05
      } else if (action.payload =="Token") {
        state.token = "USDC"
        state.betMultiplier = 10
        state.betAmount = 0.05
      }
    },
    setToken: (state, action) => {
       state.token = action.payload
    },
    increment: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value += 1
    },
    decrement: (state) => {
      state.value -= 1
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload
    },
    setTokenBalances: (state, action) => {
      state.tokenBalances = action.payload
    }
  },
})

// Action creators are generated for each case reducer function
export const { setWallet, toggleDarkMode, setMode, setToken, setTokenBalances, setBetAmount, setBetMultiplier, setLoading, toggleUserAnalytics, toggleHistoricalAnalytics, setRecentBets, toggleDegenMode, setSolBalance, setAccordionActiveKey, setShowFaq, toggleSound } = storageSlice.actions

export default storageSlice.reducer